import * as React from 'react';
import { TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';
import AfrReportsCore from '../AfrCore/AfrReportsCore';

const CR939ReportsA = (props: any) => {

    return (
        <React.Fragment>
            <AfrReportsCore taxonomyType={TaxonomyTypeEnum.COURT_REPORTING_939} publicreports={false}/>
        </React.Fragment>
    );
}

export default CR939ReportsA;